import React, { useEffect, useMemo } from "react";
import classNames from "classnames";
import { List } from "components";
import { types } from "./duck";
import styles from "./FilesList.module.css";
import { ListItem } from "./components";

const FilesList: React.FC<types.FilesListProps> = ({
  loadingFiles,
  setFilesCallback,
  setValueCallback,
  renderListItemCallback,
  areaDescribedByPrefix,
  areaDescribedByNamePrefix,
  value,
  classNameContainer,
}) => {
  const mappedFiles = useMemo(() => {
    const loadedFiles = loadingFiles.filter((item) => item.reference);

    if (loadedFiles.length) {
      return loadedFiles.map((item) => ({
        size: item.size,
        name: item.name,
        reference: item.reference,
        url: item.url,
        mimeType: item.type,
      }));
    }

    return [];
  }, [loadingFiles]);

  useEffect(() => {
    if (setValueCallback) {
      setValueCallback([...value, ...mappedFiles]);
    }
    setFilesCallback((prev) => prev.filter((item) => !item.reference));
  }, [mappedFiles.length]);

  const handleDelete: types.handleDelete = ({ tempId, reference }) => {
    if (tempId) {
      setFilesCallback((prev) => prev.filter((item) => item.tempId !== tempId));
    }
    if (reference && setValueCallback) {
      setValueCallback(value.filter((item) => item.reference !== reference));
    }
  };

  const data = useMemo(
    () => [...value, ...loadingFiles],
    [value, loadingFiles],
  );

  if (!data.length) {
    return null;
  }

  return (
    <List
      data={data}
      mapKey={(file) => file.tempId || file.reference}
      className={classNames(styles.list, classNameContainer)}
      renderItem={(file) => (
        <ListItem
          areaDescribedByNamePrefix={areaDescribedByNamePrefix}
          areaDescribedByPrefix={areaDescribedByPrefix}
          file={file}
          onDeleteCallback={handleDelete}
          renderListItemCallback={renderListItemCallback}
        />
      )}
    />
  );
};

export default FilesList;
